import React from 'react';

export default React.createContext({
    scrollPosition: {left: 0, top: 0},
    // selectedColumn: null,
    columnNames: [],
    onColumnFocus: null,
});
